export default __webpack_public_path__ + "static/media/figma.95f11db016e17f5d58c178ac45b0d86c.svg";